import { GriddleStateStore } from "./GriddleStateStore";
var GriddleStoreCom = /** @class */ (function () {
    function GriddleStoreCom(storeFrontChangeCallback) {
        var _this = this;
        this.sendMessage = function (message) {
            return _this.stateStore.sendMessage(message);
        };
        // TODO: this is very much not implemented
        // need to hook up StoreFrontChangeCallback
        this.stateStore = new GriddleStateStore();
    }
    GriddleStoreCom.create = function (callBack) {
        // singleton creation
        // There shouldn't be a need to recreate the storeRoom
        if (!GriddleStoreCom.storeCom) {
            GriddleStoreCom.storeCom = new GriddleStoreCom(callBack);
        }
        return GriddleStoreCom.storeCom;
    };
    return GriddleStoreCom;
}());
export { GriddleStoreCom };
//# sourceMappingURL=GriddleStoreCom.js.map